package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Asset_valuation(
  public val id: String,
  public val asset_id: String,
  public val date: String,
  public val value_: Long,
  public val note: String?,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
